import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton } from '~/components/atomic';

type LoginDefaultButtonProps = {
  isLoading?: boolean;
  title: string;
  disabled?: boolean;
  submit?: boolean;
  onClick?: () => void;
};

interface InnerLayout {
  children: React.ReactNode;
  buttonProps?: LoginDefaultButtonProps;
}

export default function InnerLayout({ children, buttonProps }: InnerLayout) {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (
      event.key === 'Enter' &&
      buttonProps?.onClick &&
      !buttonProps.disabled
    ) {
      buttonProps.onClick;
    }
  };

  return (
    <Container onKeyDown={handleKeyDown}>
      {children}
      {buttonProps && (
        <DefaultButton
          disabled={buttonProps.disabled}
          onClick={buttonProps.onClick}
        >
          {buttonProps.title}
        </DefaultButton>
      )}
    </Container>
  );
}

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 70px;
    padding: 0 0
      calc(
        ${theme.layout.chat_header_height} + ${theme.layout.section_side} + 30px
      );
  `}
`;
